module.exports = __webpack_public_path__ + "static/media/loading.7477cae9.gif";